export const mobileBreakpoint = 600 // px
export const tabletBreakpoint = 1199
export const productViewBreakpoint = 999
